import * as API from "@/api/shop";
import {Toast} from "vant";
import * as utils from '@/utils';
import callBuyAction from '@/components/SkuAction';

export default {
  data() {
	return {
	  buyLoading: false
	};
  },
  methods: {
	async callBuyAction() {
	  this.buyLoading = true;
	  const result = await callBuyAction({
		guid: this.data.goods_item_online_guid,
		hasSku: this.data.is_exist_sku
	  });
	  this.buyLoading = false;
	  if (!result.success) return;
	  switch (result.data.type) {
		case 'buyNow':
		  this.buyNow(result.data);
		  break;
		case 'addCart':
		  this.addCart(result.data);
		  break;
	  }
	},

	memberCheck() {
	  if (!this.$platform) return false;
	  if (!this.$platform.isMember) {
		location.href = this.$platform.registerHref;
		return false;
	  }
	  return true;
	},

	buyNow(data) {
	  if (!this.memberCheck()) return;
	  const {bid} = utils.param2Obj();

	  let submitOrderInfo = {
		source: '',
		groupSpliceGuid: '',
		groupInfoGuid: null,
		goodsBillGuid: '',
		isShopCart: false,
		goodsItems: [{
		  goodsItemOnlineGuid: this.data.goods_item_online_guid,
		  goodsItemSkuGuid: data.sku_guid,
		  number: data.count
		}]
	  };
	  sessionStorage.setItem(bid + 'submitOrderInfo', JSON.stringify(submitOrderInfo));
	  window.location.href = '/Pay/SubmitGoodsOrder?bid=' + bid;
	},

	async addCart(data) {
	  if (!this.memberCheck()) return;
	  const result = await API.addGoodsCart({
		goodsItemOnlineGuid: this.data.goods_item_online_guid,
		skuGuid: data.sku_guid,
		count: data.count,
		isAdd: true,
	  });
	  if (!result.success) return;
	  Toast.success('成功加入购物车!');
	  this.$pub && this.$pub.$emit('add-shop-cart');
	  console.log(result);
	}
  }
};
